import companyProfileSlice from './slice';

const companyProfileReducer = companyProfileSlice.reducer;

export default companyProfileReducer;
